var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0026 4.44073C19.2062 4.2622 17.4098 4.12831 15.6023 4.02789V4.01674L15.3568 2.56625C15.1895 1.53975 14.944 0 12.3331 0H9.40985C6.81013 0 6.56466 1.4728 6.38614 2.55509L6.15183 3.98326C5.11417 4.05021 4.07651 4.11715 3.03886 4.21757L0.762706 4.44073C0.294087 4.48536 -0.040641 4.89819 0.00398942 5.35565C0.0486198 5.81311 0.450293 6.14784 0.918913 6.10321L3.19506 5.88006C9.04165 5.29986 14.9329 5.52301 20.8464 6.11437C20.8799 6.11437 20.9022 6.11437 20.9356 6.11437C21.3596 6.11437 21.7278 5.7908 21.7725 5.35565C21.8059 4.89819 21.4712 4.48536 21.0026 4.44073Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3991,
    d: "M18.9491 7.68759C18.6813 7.40865 18.3131 7.25244 17.9337 7.25244H3.83054C3.45118 7.25244 3.07183 7.40865 2.8152 7.68759C2.55858 7.96653 2.41353 8.34589 2.43584 8.7364L3.12761 20.1841C3.25035 21.8801 3.40655 24 7.30056 24H14.4637C18.3577 24 18.5139 21.8912 18.6367 20.1841L19.3284 8.74756C19.3508 8.34589 19.2057 7.96653 18.9491 7.68759Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18359 17.5731C8.18359 17.111 8.55825 16.7363 9.02041 16.7363H12.7359C13.1981 16.7363 13.5727 17.111 13.5727 17.5731C13.5727 18.0353 13.1981 18.41 12.7359 18.41H9.02041C8.55825 18.41 8.18359 18.0353 8.18359 17.5731Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25586 13.1103C7.25586 12.6481 7.63052 12.2734 8.09268 12.2734H13.6715C14.1336 12.2734 14.5083 12.6481 14.5083 13.1103C14.5083 13.5724 14.1336 13.9471 13.6715 13.9471H8.09268C7.63052 13.9471 7.25586 13.5724 7.25586 13.1103Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.93bbf417feae194f7b570e212ee1d081.svg";
export { ForwardRef as ReactComponent };